"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.openVerifyFrame = void 0;
var tslib_1 = require("tslib");
var web_base_1 = require("@tencent/web-base");
var init_aegis_1 = tslib_1.__importDefault(require("../../_util/init-aegis"));
var MAX_DEFAULT_TIMEOUT = 30 * 60 * 1000; // 最大超时时间
// eslint-disable-next-line @typescript-eslint/naming-convention
var openVerifyFrame = function (params) {
    var _a;
    var page = params.page, id = params.id, containerId = params.containerId, onSuccess = params.onSuccess, onFailed = params.onFailed, onClose = params.onClose, onSkip = params.onSkip, bindWechatMethod = params.bindWechat, verifyParams = tslib_1.__rest(params, ["page", "id", "containerId", "onSuccess", "onFailed", "onClose", "onSkip", "bindWechat"]);
    var iframeContent = document.querySelector("#".concat(id));
    // 复用iframe，防止连续调用多次渲染
    var iframeId = 'meeting-components-account-real-name-verify-iframe';
    var iframeElement = iframeContent === null || iframeContent === void 0 ? void 0 : iframeContent.querySelector("#".concat(iframeId));
    if (!iframeElement) {
        iframeElement = document.createElement('iframe');
        iframeContent === null || iframeContent === void 0 ? void 0 : iframeContent.appendChild(iframeElement);
    }
    iframeElement.setAttribute('id', iframeId);
    iframeElement.setAttribute('scrolling', 'no');
    iframeElement.setAttribute('allowTransparency', 'true');
    iframeElement.style.zIndex = '10';
    iframeElement.style.border = 'none';
    iframeElement.style.width = '100vw';
    iframeElement.style.height = '100vh';
    // 转换参数
    var urlParas = {};
    Object.entries(verifyParams).forEach(function (_a) {
        var _b = tslib_1.__read(_a, 2), key = _b[0], value = _b[1];
        var type = typeof value;
        if (type === 'string' || type === 'number') {
            urlParas[key] = value;
        }
        else if (type === 'boolean') { // boolean转成1｜0
            urlParas[key] = value ? 1 : 0;
        }
        else if (type === 'object' && Array.isArray(value)) {
            var newArray = value;
            if (key === 'corp_real_name_means_list') {
                newArray = value.map(function (item) { return +item; });
            }
            urlParas[key] = (0, web_base_1.unicodeToAscii)(JSON.stringify(newArray));
        }
    });
    var sessionId = (0, web_base_1.uuidv4)();
    iframeElement.src = (0, web_base_1.addURLSearch)("".concat(location.origin).concat(page), tslib_1.__assign(tslib_1.__assign({}, urlParas), { session_id: sessionId, frame: 1 }));
    iframeElement.addEventListener('load', function () {
        var _a;
        // 在加载完成后执行其他操作
        (_a = document.querySelector('#iframe_loading_icon')) === null || _a === void 0 ? void 0 : _a.remove();
        if (iframeContent === null || iframeContent === void 0 ? void 0 : iframeContent.style) {
            iframeContent.style.backgroundColor = 'transparent';
            iframeContent.style.width = '100vw';
            iframeContent.style.height = '100vh';
        }
    });
    var bindWechat = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            document.getElementById(containerId).style.display = 'none';
            bindWechatMethod({ timeout: MAX_DEFAULT_TIMEOUT }).then(function (res) {
                init_aegis_1.default.logAll("[real-name-verify] bindWechat res: ".concat(res));
                var bizCode = res.bizCode;
                // 绑定成功
                if (bizCode === 0) {
                    onSuccess(null);
                    return;
                }
                onFailed({
                    type: 'bind_wechat',
                    bizCode: bizCode,
                });
                setTimeout(function () {
                    document.getElementById(containerId).style.display = 'block';
                }, 2000);
            })
                .catch(function (result) {
                init_aegis_1.default.logAll("[real-name-verify] bindWechat error: ".concat(result));
                onFailed({
                    type: 'bind_wechat',
                    bizCode: -1,
                });
                setTimeout(function () {
                    document.getElementById(containerId).style.display = 'block';
                }, 2000);
            });
            return [2 /*return*/];
        });
    }); };
    // eslint-disable-next-line complexity
    var messageListener = function (event) {
        init_aegis_1.default.logAll("[real-name-verify] frame postmessage: ".concat(event));
        try {
            var origin_1 = event.origin;
            if ((0, web_base_1.isLocalEnv)(origin_1) || (0, web_base_1.isNormalEnv)(origin_1) || (0, web_base_1.isPreReleaseEnv)(origin_1) || (0, web_base_1.isTestEnv)(origin_1)) {
                var data = JSON.parse(event === null || event === void 0 ? void 0 : event.data);
                if ((data === null || data === void 0 ? void 0 : data.type) === 'success' && (data === null || data === void 0 ? void 0 : data.sessionId) === sessionId) {
                    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(data.value);
                }
                if ((data === null || data === void 0 ? void 0 : data.type) === 'failed' && (data === null || data === void 0 ? void 0 : data.sessionId) === sessionId) {
                    onFailed === null || onFailed === void 0 ? void 0 : onFailed(data.value);
                }
                if ((data === null || data === void 0 ? void 0 : data.type) === 'close' && (data === null || data === void 0 ? void 0 : data.sessionId) === sessionId) {
                    onClose === null || onClose === void 0 ? void 0 : onClose(data.value);
                }
                if ((data === null || data === void 0 ? void 0 : data.type) === 'skip' && (data === null || data === void 0 ? void 0 : data.sessionId) === sessionId) {
                    onSkip === null || onSkip === void 0 ? void 0 : onSkip(data.value);
                }
                // iframe内无法调用jsapi，所以移动端app内绑定微信需要宿主页面进行处理
                if ((data === null || data === void 0 ? void 0 : data.type) === 'bind_wechat' && (data === null || data === void 0 ? void 0 : data.sessionId) === sessionId) {
                    bindWechat();
                }
                if ((data === null || data === void 0 ? void 0 : data.type) === 'resize' && (data === null || data === void 0 ? void 0 : data.sessionId) === sessionId && iframeElement && !(0, web_base_1.isMobile)()) {
                    var resizeData = data.value;
                    if ((resizeData === null || resizeData === void 0 ? void 0 : resizeData.width) > 0) {
                        iframeElement.style.width = "".concat(resizeData.width, "px");
                    }
                    if ((resizeData === null || resizeData === void 0 ? void 0 : resizeData.height) > 0) {
                        iframeElement.style.height = "".concat(resizeData.height, "px");
                    }
                }
            }
        }
        catch (ex) {
            init_aegis_1.default.logAll("[real-name-verify] frame postmessage error: ".concat(ex));
        }
    };
    if (((_a = iframeElement === null || iframeElement === void 0 ? void 0 : iframeElement.contentWindow) === null || _a === void 0 ? void 0 : _a.postMessage) && window.addEventListener) {
        window.removeEventListener('message', messageListener);
        window.addEventListener('message', messageListener);
    }
};
exports.openVerifyFrame = openVerifyFrame;
//# sourceMappingURL=verify-frame.js.map